import heroImage from "./hero.webp";
import Cloth from "./cloth.webp";
import Skin from "./skin.png";
import Dental from "./dental.webp";
import candidImg from "./candid.png";
import mohammadzadehImg from "./navid-mohammadzadeh.png";
import dermatypique from "./dermatypique.png";
import fuliplex from "./fuliplex.png";
import ginagenImg from "./ginagen.png";
import DentalRemoveBg from "./Dental-removebg.png";
import SkinRemoveBg from "./Skin-removebg-preview.png";
import hamrahImage from "./hamrah.png";
import irancellImage from "./irancell.png";
import rightelImage from "./rightel.png";
import marvelLifeImage from "./MarvelLife.png";
import silverCiricleImg from "./Silver.webp";
import bozouxImg from "./bizoux.webp";
import footerMarvelImg from "./footerMarvel.png";
import silverCreicleMobile from "./silverShotMobile.png";
import heroCloth from "./heroCloth.png";
import silverHeroImg from "./silverHeroImg.png";
import goldHeroImg from "./heroGold.png";
import labImg1 from "./Lablatory1.webp";
import labImg2 from "./lablatory2.webp";
import noSvg from "./receiptNok.webp";
import okSvg from "./receiptOk.webp";
import emptyCart from "./emptyCart.png";
import authPaper from "./authPaper.png";
import marvelLifeStiky from "./marveLifeStiky.png";
import carImg from "./car.png";
import NotFoundImg from "./NotFound.svg";
import googlePlay from "./googlePlay.png";
import apptSore from "./apptSore.png";

export {
  heroImage,
  Cloth,
  Skin,
  SkinRemoveBg,
  Dental,
  DentalRemoveBg,
  candidImg,
  mohammadzadehImg,
  dermatypique,
  fuliplex,
  ginagenImg,
  hamrahImage,
  irancellImage,
  rightelImage,
  marvelLifeImage,
  silverCiricleImg,
  bozouxImg,
  footerMarvelImg,
  silverCreicleMobile,
  heroCloth,
  silverHeroImg,
  goldHeroImg,
  labImg1,
  labImg2,
  noSvg,
  okSvg,
  emptyCart,
  authPaper,
  marvelLifeStiky,
  carImg,
  NotFoundImg,
  googlePlay,
  apptSore,
};
